import {OptionTypeBase} from 'platform/components';

export interface BranchOptionsItem extends OptionTypeBase<string> {
  label: string;
  value: string;
}
